<template>
  <div v-if="!loading">
    <div v-if="!lastPaymentPaid.hasOwnProperty('payment_method')" class="upgrade-layout">
      <p-company-upgrade v-model="client" :billingType="this.subscription.billingType" :dialog="customerDataDialog" @dialog="(val)=>{customerDataDialog = val}" @save="saveCompany" ref="companyEdit"></p-company-upgrade>    
        <!-- Dialog de erro no pagamentoooo ------------------------------------------------->
        <v-dialog v-model="dialogPaymentError" scrollable width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Ocorreu um problema
          </v-card-title>
          <v-card-text>
            <div class="text-column">
              <span><strong>Erro: </strong>{{this.paymentError.code}}</span>
              <span><strong>Mensagem: </strong>{{this.paymentError.description}}</span>
              <div class="last-payment-body">
                <div class="text-column">
                  <h4>Para melhor esclarecimento, entre em contato com nosso suporte ao lado, ou pelas opções abaixo!</h4>
                  <br>
                  <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span>
                  <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialogPaymentError = false">Sair</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIMM Dialog de erro no pagamentoooo ------------------------------------------------->
      <!-- Dialog Confimação de pagamentoooo ------------------------------------------------->
      <v-dialog v-model="dialogPaymentConfirm" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Confirmação do Pagamento
          </v-card-title>
          <v-card-text>
             <div class="text-column">
              <span><strong>Plano: </strong>{{itemsPlan.find((val)=>{return val.id === this.selected_plan}).id_text}}</span>
              <span><strong>Forma de Cobrança: </strong>{{this.subscription.cycle === 'MONTHLY' ? 'Mensal' : 'Anual'}}</span>
              <span><strong>Método de Pagamento: </strong>{{this.subscription.billingType === 'CREDIT_CARD' ? 'Cartão' : 'Boleto'}}</span>
              <span v-if="(parseFloat(cupom.value) > 0)"><strong>Cupom de Desconto: </strong>{{(cupom.type === 1 ? parseInt(cupom.value) + '%' : ' R$ ' + parseFloat(cupom.value).toFixed(2))}}{{txtQtdMonth()}}</span>
              <span><strong>Valor {{this.subscription.cycle === 'MONTHLY' ? txtQtdMonth('da fatura') : (this.cupom['qtd_month'] ? 'no 1º ano' : 'da fatura')}}:</strong> R$ {{this.subscription.cycle === 'MONTHLY' ? this.valueMouth : this.valueYear}}</span>
              <span v-if="cupom['qtd_month']"><strong>{{this.subscription.cycle === 'MONTHLY' ? 'Nos outros meses: ' : 'Nos outros anos: '}}</strong>R$ {{this.subscription.cycle === 'MONTHLY' ? valueMouthWithoutCupom : (valueMouthWithoutCupom * 12 * 0.9).toFixed(2)}}</span>
              <span v-if="this.subscription.cycle === 'MONTHLY'"><strong>Fatura: </strong>Será gerado uma fatura todo mês, na aba de faturas no gerenciamento da empresa.</span>
              <span v-if="this.subscription.billingType === 'CREDIT_CARD'">Para maior comodidade, o pagamento no cartão será automático.</span>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="consultCustomerData">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FIM Confimação de pagamentoooo ------------------------------------------------------>

      <v-layout row wrap justify-center>
        <v-flex xs12>
          <div class="text-xs-center">
            <span class="display-1" style="word-break: break-word;">
              Faça Upgrade da <span class="name-company" color="primary">{{this.company_name}}</span>
            </span>
          </div>
        </v-flex>
        <v-flex xs12 md2></v-flex>
        <v-flex xs12>
          <v-form ref="formCustom" class="mb-1">
            <v-layout wrap justify-center align-center>
              <v-flex xs1 sm3 md4></v-flex>
              <v-flex xs4 sm3 md2>
               <v-container>
                  <h4>Usuários</h4>
                  <v-select
                    hide-details
                    :disabled="disableUser"
                    @change="changeUser"
                    :items="[{value: 3, text: '3 usuários'}, {value: 5, text: '5 usuários'}, {value: 10, text: '10 usuários'}, {value: 15, text: '15 usuários'}, {value: 20, text: '20 usuários'}, {value: 25, text: '25 usuários'}, {value: 30, text: '30 usuários'}, {value: 40, text: '40 usuários'}, {value: 50, text: '50 usuários'}, {value: 70, text: '70 usuários'}, {value: 100, text: '100 usuários'}, {value: 200, text: '200 usuários'}, {value: 0, text: '+200 usuários'}]"
                    v-model="qtdUser"
                    label="Usuários"
                    solo
                  ></v-select>
               </v-container>
              </v-flex>
              <v-flex xs4 sm3 md2>
               <v-container>
                  <h4>Armazenamento</h4>
                  <v-select
                    hide-details
                    :disabled="disableMemory"
                    @change="changeMemory"
                    :items="[{value: 10, text: '10 GB'}, {value: 15, text: '15 GBs'}, {value: 20, text: '20 GBs'}, {value: 30, text: '30 GBs'}, {value: 40, text: '40 GBs'}, {value: 50, text: '50 GBs'}, {value: 100, text: '100 GBs'}, {value: 150, text: '150 GBs'}, {value: 200, text: '200 GBs'}, {value: 300, text: '300 GBs'}, {value: 0, text: '+300 GBs'}]"
                    v-model="qtdMemory"
                    label="Armazenamento"
                    solo
                  ></v-select>
               </v-container>
              </v-flex>
              <v-flex xs3 sm3 md4>
                <a href="https://illis.com.br/planos" target="_blank">Sobre os planos</a>
              </v-flex>
            </v-layout>
            <div v-if="!cupom.active && consultantActive == false" class="text-xs-center py-3">
              <a @click="consultantActive = true"><strong>clique Aqui</strong>, caso tenha algum consultor!</a>
            </div>
            <v-layout v-if="cupom.active || consultantActive" wrap justify-center align-center>
              <v-flex xs1 sm3 md4></v-flex>
              <v-flex xs2 sm4 md3>
                <v-text-field v-if="consultantActive" @keyup.native.enter="confirmCupom" v-model="cupom.id_text" label="Digite o código do consultor" :error="cupom.error"  hide-details></v-text-field>
                <v-text-field v-if="cupom.active" @keyup.native.enter="confirmCupom" v-model="cupom.id_text" label="Digite o seu cupom" :error="cupom.error" hide-details></v-text-field>
                <div class="v-messages pt-1" :style="'color:'+cupom.hintColor">{{cupom.hint}}</div>
              </v-flex>
              <v-flex xs2 sm1 md1>
                <v-btn v-if="cupom['id']" @click="confirmCupom" :loading="cupom.loading" color="success">Confirmado</v-btn>
                <v-btn v-else @click="confirmCupom" :loading="cupom.loading">Confirmar</v-btn>
              </v-flex>
              <v-flex xs3 sm3 md4></v-flex>
            </v-layout>
          </v-form>
        </v-flex>
        <v-layout v-if="this.qtdUser === 0 || this.qtdMemory === 0" v-layout row wrap justify-center align-center>
          <v-flex :class="$vuetify.breakpoint.smAndDown ? 'xs12 mb-4' : 'xs6 mb-4'">
            <div class="last-payment-container">
              <h2 class="title-upgrade">Vimos que sua empresa precisa de um plano diferenciado!</h2>
              <div class="last-payment-body">
                <div class="text-column">
                  <h3>Entre em contato com nosso suporte ao lado, ou pelas opções abaixo, para negociarmos os melhores valores!</h3>
                  <br>
                  <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span>
                  <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <!-- // usado o v-show pois o cartão estava sumindo bug 1929.1 -->
        <v-layout wrap justify-center align-center v-show="!(this.qtdUser === 0 || this.qtdMemory === 0)">
          <v-flex xs12 mb-4>
            <div class="text-xs-center">
              <span class="title">
                Selecione uma Forma de Cobrança
              </span>
            </div>
          </v-flex>

          <v-flex xs12 md3></v-flex>

          <v-flex xs12 md3>
            <v-card :color="subscription.cycle == 'MONTHLY' ? 'primary darken-2' : 'white'"
                    :dark="subscription.cycle == 'MONTHLY'" :class="{'elevation-12': subscription.cycle == 'MONTHLY'}"
                    height="170">
              <v-layout align-center justify-center column fill-height>
                <span class="body-1 text-xs-center">Mensal</span>
                <div>
                  <span class="title">R$ {{valueMouth}}</span>
                  <span class="caption">{{txtQtdMonth('ao mês')}}</span><br>
                </div>
                <div class="text-xs-center">
                  <span class="caption">(R$ {{(valueMouth/this.qtdUser).toFixed(2)}}/por usuário)</span><br>
                </div>
                <v-chip v-if="(parseFloat(cupom.value) > 0)" color="green" small class="mb-0" text-color="white">
                    Cupom de {{cupom.type === 1 ? parseInt(cupom.value) + '%' : 'R$ ' + parseFloat(cupom.value).toFixed(2)}}
                </v-chip>
                <div class="text-xs-center">
                  <v-btn :class="subscription.cycle == 'MONTHLY' ? 'black--text' : ''" round
                        @click="subscription.cycle = 'MONTHLY'"
                        :color="subscription.cycle == 'MONTHLY' ? 'grey lighten-5' : 'primary darken-2'">
                    {{subscription.cycle == 'MONTHLY' ? 'Selecionado' : 'Selecionar' }}
                  </v-btn>
                </div>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 md3 pt-3 v-if="$vuetify.breakpoint.smAndDown">
            <v-card :color="subscription.cycle == 'YEARLY' ? 'primary darken-2' : 'white'"
                    :dark="subscription.cycle == 'YEARLY'" :class="{'elevation-12': subscription.cycle == 'YEARLY'}"
                    height="170">
              <v-layout align-center justify-center column fill-height>
                <span class="body-1 text-xs-center">Anual</span>
                <div>
                  <span class="title">R$ {{(valueYear / 12).toFixed(2)}}</span>
                  <span class="caption">{{txtQtdMonth('ao mês')}}</span>
                  <div class="text-xs-center">
                    <span class="caption">(R$ {{(valueYear/12/this.qtdUser).toFixed(2)}}/por usuário)</span><br>
                  </div>
                  <div class="text-xs-center">
                    <span class="caption">(R$ {{valueYear}})</span><br>
                  </div>
                </div>
                <v-flex xs12>
                  <v-chip v-if="(parseFloat(cupom.value) > 0)" color="green" small class="mb-0" text-color="white">
                      Cupom de {{cupom.type === 1 ? parseInt(cupom.value) + '%' : 'R$ ' + parseFloat(cupom.value).toFixed(2)}}
                  </v-chip>
                  <v-chip color="green" small class="mb-0" text-color="white" v-if="subscription.plane != 'toCombine'">
                    Economia de 10%
                  </v-chip>
                </v-flex>
                <div class="text-xs-center">
                  <v-btn :class="subscription.cycle == 'YEARLY' ? 'black--text' : ''" round
                        @click="subscription.cycle = 'YEARLY'"
                        :color="subscription.cycle == 'YEARLY' ? 'grey lighten-5' : 'primary darken-2'">
                    {{subscription.cycle == 'YEARLY' ? 'Selecionado' : 'Selecionar' }}
                  </v-btn>
                </div>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 md3 pl-3 v-else>
            <v-card :color="subscription.cycle == 'YEARLY' ? 'primary darken-2' : 'white'"
                    :dark="subscription.cycle == 'YEARLY'" :class="{'elevation-12': subscription.cycle == 'YEARLY'}"
                    height="170">
              <v-layout align-center justify-center column fill-height>
                <span class="body-1 text-xs-center">Anual</span>
                <div>
                  <span class="title">R$ {{(valueMouth * 0.9).toFixed(2)}}</span>
                  <span class="caption">{{txtQtdMonth('ao mês')}}</span>
                  <div class="text-xs-center">
                    <span class="caption">(R$ {{(valueMouth*0.9/this.qtdUser).toFixed(2)}}/por usuário)</span><br>
                  </div>
                  <div class="text-xs-center">
                    <span class="caption">(R$ {{valueYear}})</span><br>
                  </div>
                </div>
                <v-flex xs12>
                  <v-chip v-if="(parseFloat(cupom.value) > 0)" color="green" small class="mb-0" text-color="white">
                    Cupom de {{cupom.type === 1 ? parseInt(cupom.value) + '%' : 'R$ ' + parseFloat(cupom.value).toFixed(2)}}
                  </v-chip>
                  <v-chip color="green" small class="mb-0" text-color="white" v-if="subscription.plane != 'toCombine'">
                    Economia de 10%
                  </v-chip>
                </v-flex>
                <div class="text-xs-center">
                  <v-btn :class="subscription.cycle == 'YEARLY' ? 'black--text' : ''" round
                        @click="subscription.cycle = 'YEARLY'"
                        :color="subscription.cycle == 'YEARLY' ? 'grey lighten-5' : 'primary darken-2'">
                    {{subscription.cycle == 'YEARLY' ? 'Selecionado' : 'Selecionar' }}
                  </v-btn>
                </div>
              </v-layout>
            </v-card>
          </v-flex>

          <v-flex xs12 md3></v-flex>

          <v-flex xs12 mt-4 mb-4>
            <div class="text-xs-center">
              <span class="title">
                Informe os Dados para Pagamento
              </span>
            </div>
          </v-flex>
          <v-flex xs12 md2></v-flex>
          <v-flex xs12 md3>
            <div class='card-wrapper'></div>
          </v-flex>
          <v-flex xs12 md5>
            <form id="cartao">
              <v-layout ml-2 row wrap>
                <v-flex xs10>
                  <v-text-field label="Nome Escrito no Cartão" id="creditCardHolderName" v-model="card.creditCardHolderName"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field :mask="'credit-card'" v-model="card.creditCardNumber" id="creditCardNumber" label="Número do Cartão de Crédito"></v-text-field>
                </v-flex>

                <!-- <v-flex xs12 md3 v-if="$vuetify.breakpoint.smAndDown">
                  <v-text-field placeholder="MM/YYYY" mask="##/####" label="Data de Vencimento" id="creditCardExpiry" v-model="card.creditCardExpiry"></v-text-field>
                </v-flex> -->
                <v-flex xs12 md3 px-2>
                  <v-text-field placeholder="MM/YYYY" mask="##/####" label="Data de Vencimento" id="creditCardExpiry" v-model="card.creditCardExpiry"></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field :mask="'###'" label="cvv" id="creditCardCvv" v-model="card.creditCardCcv"></v-text-field>
                </v-flex>
              </v-layout>
            </form>
            <!-- <small>Para maior comodidade, o pagamento no cartão será automático.</small> -->
            <v-layout row wrap my-3>
              <v-flex :class="boleto ? 'xs12 md4' : 'xs12 md10'">
                <div class="text-xs-center btn-comprar">
                  <v-btn large round color="primary darken-2" @click="openPaymentConfirm('CREDIT_CARD')">
                    Comprar
                  </v-btn>
                </div>
              </v-flex>

              <v-flex v-show="boleto" xs12 md6 elevation-2 pt-2 pb-3>
                <p class="subheading text-xs-center font-weight-medium" style="margin: 0">Outra Forma de Pagamento?</p>
                <v-layout align-center justify-space-around row fill-height>
                  <v-btn large color="primary" @click="openPaymentConfirm('BOLETO')">Boleto</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md2></v-flex>
        </v-layout>
      </v-layout>
    </div>
    <div v-else-if="lastPaymentPaid['last_bill'].length > 0" class="upgrade-last-payment">
      <v-layout row wrap justify-center>
        <div class="last-payment-container">
          <h2 class="title-upgrade">Consulte seu Plano e sua Última Fatura</h2>

          <div class="last-payment-body">
            <div class="text-column">
              <span>Status:</span>
              <span>Plano:</span>
              <span>Método de Pagamento:</span>
              <span v-if="lastPaymentPaid.last_bill[0].expired">Expiração do Plano:</span>
              <span v-else-if="lastPaymentPaid.last_bill[0].due_date">Vencimento da Fatura:</span>
            </div>
            <div class="values-column">
              <span :style="'color: ' + getColorStatus(lastPaymentPaid.last_bill[0].payment_status)">{{getStatus(lastPaymentPaid.last_bill[0].payment_status)}}</span>
              <span>{{lastPaymentPaid.plan.id_text}}</span>
              <span>{{getPaymentMethod(lastPaymentPaid.payment_method)}}</span>
              <span v-if="lastPaymentPaid.last_bill[0].expired" :style="'color: ' + getColorActiveStatus(lastPaymentPaid.last_bill[0].expired)">{{lastPaymentPaid.last_bill[0].expired | formatDate}}</span>          
              <span v-else-if="lastPaymentPaid.last_bill[0].due_date" :style="'color: ' + getColorActiveStatus(lastPaymentPaid.last_bill[0].due_date)">{{lastPaymentPaid.last_bill[0].due_date | formatDate}}</span>          
            </div>
          </div>
          <v-flex>
            <span v-if="lastPaymentPaid.last_bill[0].payment_status === 'PENDING' && lastPaymentPaid.payment_method === 'CREDIT_CARD'">
              Favor aguardar alguns segundos e
              <a @click="reloadPagePlan()">clique aqui</a>
              para atualizar o seu plano!
            </span>
            <a v-else-if="(lastPaymentPaid.payment_method === 'BOLETO') && (!lastPaymentPaid.last_bill[0].paid)" target="_blank" :href="lastPaymentPaid.last_bill[0].billet_url">Link do Boleto</a>
          </v-flex>
          <v-flex>
            <v-btn flat color="primary" @click="clickMigratePlan">Migrar de Plano</v-btn>
            <v-btn color="primary" :to="'/company/' + $auth.user().company_id + '?tab=1'">Visualizar Faturas</v-btn>
          </v-flex>
          <v-layout v-if="migratePlan" v-layout row wrap justify-center align-center>
            <div class="last-payment-container">
              <h2 class="title-upgrade">Migrar de plano!</h2>
              <div class="last-payment-body">
                <div class="text-column">
                  <h3>Entre em contato com nosso suporte ao lado ou pelas opções abaixo!</h3>
                  <br>
                  <span><strong>Telefone: </strong><strong style="color: blue;">(34) 99910-0135</strong></span>
                  <span><strong>Email: </strong><strong style="color: blue;">suporte.sistema@illissolucoes.com.br</strong></span>
                </div>
              </div>
            </div>
          </v-layout>
        </div>
      </v-layout>
    </div>
    <div v-else class="upgrade-last-payment">
      <v-layout row wrap justify-center>
        <div class="last-payment-container">
          <h2 class="title-upgrade">Aguardando confirmação do pagamento</h2>
          <div class="last-payment-body">
            <div class="text-column">
              <span>Caso o pagamento tenha sido feito corretamente e estiver demorando, fique a vontade para entrar em contato com o nosso suporte.</span>
            </div>
          </div>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<script>
  /* eslint-disable eqeqeq, camelcase, brace-style */
  import crud from '../mixin/crud'
  import rules from '../mixin/rules'
  import access from '../mixin/access'
  import planLayout from '../mixin/planLayout'
  import PCompanyUpgrade from './shared/PCompanyUpgrade'
  var Card = require('card')
  export default {
    mixins: [crud, rules, access, planLayout],
    components: {PCompanyUpgrade},
    data: () => ({
      client: {
        type_person: 1, // 1 => fisica, 2 => juridica
        id_text: '',
        cpfcnpj: '',
        city: '',
        state: '',
        cep: '',
        neighborhood: '',
        complement: '',
        address: '',
        number: '',
        phone: '',
        email: ''
      },
      itemsPlan: [{ id: 2, id_text: 'Business' }, { id: 4, id_text: 'Personalizado' }],
      qtdUser: 3,
      qtdMemory: 10,
      moreValue: 0,
      consultantActive: false,
      migratePlan: false,
      boleto: false,
      disableUser: false,
      disableMemory: false,
      cupom: {id: null, id_text: '', type: 2, value: 0, active: false, description: '', loading: false, hint: '', hintColor: 'gray'},
      paymentError: { code: 0, description: '' },
      dialogPaymentError: false,
      dialogPaymentConfirm: false,
      loading: false,
      lastPaymentPaid: {
        payment_method: '',
        plan: {
          id_text: ''
        },
        last_bill: [{
          payment_status: '',
          billet_url: '',
          paid: false,
          expired: null
        }]
      },
      customerDataDialog: false,
      field_errors: [{ field: 'cpfcnpj', text: '', loading: false }],
      menu: false,
      modal: false,
      current_plan: 1,
      selected_plan: 2,
      company_name: 'Empresa',
      card: {
        creditCardCcv: '',
        creditCardHolderName: '',
        creditCardNumber: '',
        creditCardExpiry: '',
        creditCardExpiryMonth: '',
        creditCardExpiryYear: ''
      },
      subscription: {
        plane: 'business',
        billingType: 'CREDIT_CARD',
        cycle: 'MONTHLY'
      }
    }),
    created () {
      // Gera os dois primeiros nomes da empresa pra mostrar pro usuário
      let companyName = this.$auth.user().company.id_text.split(' ')
      this.company_name = `${companyName[0]} ${companyName[1] ? companyName[1] : ''}`
      this.$store.commit('loader/change_dialog', true)
      this.loading = true
      this.current_plan = this.$auth.user().company.company_plan.length > 0 ? this.$auth.user().company.company_plan[0].plan_id : 1
      this.$http.get(`api/last_payment_paid`).then(res => {
        this.lastPaymentPaid = res.body
        this.$store.commit('loader/change_dialog', false)
        this.loading = false
        if (!Object.keys(this.lastPaymentPaid).length) {
          this.makeCardForm()
        }
      }, err => {
        console.log(err)
        this.$store.commit('loader/change_dialog', false)
      })
    },
    mounted () {
      // Verifica se o link é algum personalizado para colocar mais valor que o do plano
      // o link vira codificado
      // exemplo dos valores descodificados
      if (this.$route.query['usuario']) {
        this.qtdUser = parseInt(this.$route.query['usuario'])
        this.disableUser = true
      }
      if (this.$route.query['memoria']) {
        this.qtdMemory = parseInt(this.$route.query['memoria'])
        this.disableMemory = true
      }
      if (this.$route.query['maisValor']) {
        this.moreValue = Math.abs(parseFloat(this.$route.query['maisValor']))
      }
      // Habilitade boleto
      this.boleto = this.$route.query['boleto'] ? this.$route.query['boleto'] : this.boleto
      // {cupomActive: true, this.$route.query['cupom']: 'cupom'},
      // caso tenha algum cupom já insere ele
      this.cupom.active = this.$route.query['cupomActive'] ? this.$route.query['cupomActive'] : this.cupom.active
      if (this.$route.query['cupom']) {
        this.cupom.id_text = this.$route.query['cupom']
        this.confirmCupom()
      }
    },
    methods: {
      reloadPagePlan () {
        location.reload(true)
      },
      returnError () {
        this.$store.commit('loader/change_dialog', false)
        this.$store.commit('snackbar/change_values', {
          text: 'Não foi possível realizar a compra, favor entrar em contato com nosso suporte.', color: 'error', dialog: true
        })
      },
      openPaymentConfirm (method) {
        if (method === 'CREDIT_CARD') {
          if (this.card.creditCardNumber === '' || this.card.creditCardExpiry === '' || this.card.creditCardExpiry.length < 4 || this.card.creditCardCcv === '') {
            this.$store.commit('snackbar/change_values', {
              text: 'Favor informar o número do cartão, o vencimento e o cvv.', color: 'warning', dialog: true
            })
            return false
          }
        }
        this.subscription['billingType'] = method
        this.dialogPaymentConfirm = true
      },
      consultCustomerData () {
        this.dialogPaymentConfirm = false
        this.$store.commit('loader/change_dialog', true)
        // this.$store.commit('loader/change_dialog', true)
        // Caso o id_text seja vazio busca os valores da empresa no banco, caso não seja vazio já pega os valores direto
        if (this.client['id_text'] == '') {
          this.$http.get(`api/get_company_clean/${this.$auth.user().company_id}`).then(res => {
            this.buyProcess(res.body)
          }, err => {
            console.log(err)
            this.returnError()
            this.$store.commit('loader/change_dialog', false)
          })
        } else {
          this.buyProcess()
        }
      },
      buyProcess (values = this.client) {
        Object.assign(this.client, values)
        // Insere o email do usuário no momento de fazer a compra
        this.client.email = this.$auth.user().email
        setTimeout(() => {
          if (!this.$refs.companyEdit.formValidate) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, todos os dados obrigatórios antes de salvar!',
              color: 'warning',
              dialog: true
            })
          }
          this.$store.commit('loader/change_dialog', false)
          this.customerDataDialog = true
        }, 200)
      },
      saveCompany (values) {
        Object.assign(this.client, values)
        this.customerDataDialog = false
        this.buy()
      },
      buy () {
        // cartão para teste
        // \"holderName\": \"marcelo h almeida\",
        // \"number\": \"5162306219378829\",
        // \"expiryMonth\": \"05\",
        // \"expiryYear\": \"2021\",
        // \"ccv\": \"318\"
        this.card['creditCardExpiryMonth'] = String(this.card['creditCardExpiry'].substr(0, 2))
        this.card['creditCardExpiryYear'] = String(this.card['creditCardExpiry'].substr(-2))
        let params = {
          subscription: this.subscription,
          client: this.client,
          card: this.card,
          moreValue: this.moreValue,
          qtdUser: this.qtdUser,
          qtdMemory: this.qtdMemory,
          cupom: this.cupom['id_text']
        }
        this.$store.commit('loader/change_dialog', true)
        this.$http.post(`api/create_subscription`, params).then(res => {
          this.$store.commit('loader/change_dialog', false)
          // Se tiver o billingType é pq deu certo
          if (res.body.hasOwnProperty('billingType')) {
            // abre o boleto caso seja boleto
            if (res.body['billingType'] === 'BOLETO') window.open(res.body['bills']['data'][0]['bankSlipUrl'], '_blank')
            location.reload()
            // this.$store.commit('loader/change_dialog', false)
            // O erro pode vir com errors ou em forma de array(exemplo o cartão naõ dunciona)
          } else if (res.body.hasOwnProperty('errors') || Array.isArray(res.body)) {
            Object.assign(this.paymentError, res.body.hasOwnProperty('errors') ? res.body['errors'][0] : res.body[0])
            if ((typeof this.paymentError.description === 'string') && this.paymentError.description.includes('Tipo inválido: null')) {
              this.paymentError.description = 'Favor verificar os dados do cartão.'
            }
            this.dialogPaymentError = true
            document.getElementById('purechat-btn').click()
            this.dialogPaymentConfirm = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível completar seu pagamento! verificar as informações do cartão ou entrar em contato com nosso suporte.',
              timeout: 10000,
              color: 'error',
              dialog: true
            })
            return false
          } else {
            this.$store.commit('snackbar/change_values', {
              text: 'Pode ter ocorrido problemas no pagamento! favor entrar em contato com nosso suporte.',
              timeout: 15000,
              color: 'error',
              dialog: true
            })
          }
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível completar seu pagamento! favor entrar em contato com nosso suporte.',
            timeout: 10000,
            color: 'error',
            dialog: true
          })
          this.$store.commit('loader/change_dialog', false)
        })
      },
      confirmCupom () {
        Object.assign(this.cupom, {loading: true, hint: '', hintColor: 'gray'})
        this.$http.get(`api/check_cupom/${this.cupom.id_text}`).then(res => {
          // tira o ativo para não interferir no já existente
          delete res.body.active
          Object.assign(this.cupom, res.body, {error: false, loading: false, hintColor: 'green'})
          // se as inicials for PC significa que o cupom é de um consultor, se não é um cupom de desconto normal
          this.cupom['hint'] = (res.body['id_text'].substr(0, 2) == 'PC') ? 'Consultor: ' + this.cupom['description'] : ('Desconto: ' + (this.cupom['type'] === 1 ? parseInt(this.cupom['value']) + '%' : ' R$ ' + parseFloat(this.cupom['value']).toFixed(2)) + '' + this.txtQtdMonth())
        }, err => {
          this.cupom['hint'] = this.consultantActive ? 'Código inválido' : 'Cupom inválido'
          Object.assign(this.cupom, {id: null, error: true, loading: false, hintColor: 'red'})
          console.log(err)
        })
      },
      makeCardForm () {
        setTimeout(function () {
          var card = new Card({
            form: '#cartao', // *required*
            container: '.card-wrapper', // *required*

            formSelectors: {
              numberInput: '#creditCardNumber', // optional — default input[name="number"]
              expiryInput: '#creditCardExpiry', // optional — default input[name="expiry"]
              cvcInput: '#creditCardCvv', // optional — default input[name="cvv"]
              nameInput: '#creditCardHolderName' // optional - defaults input[name="name"]
            },

            width: '100%', // optional — default 350px
            placeholders: {
              number: '•••• •••• •••• ••••',
              name: '',
              expiry: '••/••••',
              cvv: '•••'
            }
          })
          console.log('card', card)
        }, 1000)
      },
      // *IMPORTANTE* valueUser Tbm está sendo calculado no back, se mudar mudar no BACK
      valueUser (qtd) {
        // Tira 1 centavo para ficar um valor com 9 no final
        // switch (parseInt(qtd)) {
        //   case 1: return (qtd * 16) - 0.01
        //   case 3: return (qtd * 13) - 0.01
        //   case 5: return (qtd * 12.50) - 0.01
        //   case 10: return (qtd * 12) - 0.01
        //   case 15: return (qtd * 11.50) - 0.01
        //   case 20: return (qtd * 11.00) - 0.01
        //   case 25: return (qtd * 10.50) - 0.01
        //   default: return (qtd * 10.00) - 0.01
        // }
        return ((qtd * 39.90))
      },
      // *IMPORTANTE* valueMemory Tbm está sendo calculado no back, se mudar mudar no BACK
      valueMemory (qtd) {
        // if (parseInt(qtd) === 1) return (qtd * 3.0)
        // else if (parseInt(qtd) <= 10) return (qtd * 2.50)
        // else return (qtd * 2.0)
        let priceQtd = qtd - 10
        // O usuário já começa com 10 gigas, se ultrapassar paga 2,5 por giga
        return (priceQtd <= 0) ? 0 : (priceQtd * 2.50)
      },
      clickMigratePlan () {
        document.getElementById('purechat-btn').click()
        this.migratePlan = true
      },
      changeMemory (qtd) {
        if (qtd === 0) document.getElementById('purechat-btn').click()
      },
      changeUser (qtd) {
        if (qtd === 0) document.getElementById('purechat-btn').click()
      },
      txtQtdMonth (empty = '') {
        return this.cupom['qtd_month'] ? (this.cupom['qtd_month'] === 1 ? ' no 1º mês' : ' por ' + this.cupom['qtd_month'] + ' meses') : empty
      }
    },
    computed: {
      valueMouthWithoutCupom () {
        return (this.valueUser(this.qtdUser) + this.valueMemory(this.qtdMemory) + this.moreValue).toFixed(2)
      },
      valueMouth () {
        // *IMPORTANT* Qualquer alteração nos valores deve ser alterado no BACK
        let value = this.valueUser(this.qtdUser) + this.valueMemory(this.qtdMemory) + this.moreValue
        if (parseFloat(this.cupom.value) > 0) {
          value = this.cupom.type == 1 ? (value - (value * (parseFloat(this.cupom.value) / 100))) : (value - parseFloat(this.cupom.value))
        }
        return value < 1 ? 1 : value.toFixed(2)
      },
      valueYear () {
        // *IMPORTANT* Qualquer alteração nos valores deve ser alterado no BACK
        // let value = ((this.valueUser(this.qtdUser) + this.valueMemory(this.qtdMemory) + this.moreValue) * 12 * 0.9)
        // if (parseFloat(this.cupom.value) > 0) {
        //   value = this.cupom.type == 1 ? (value - (value * (parseFloat(this.cupom.value) / 100))) : (value - (parseFloat(this.cupom.value) * 12))
        // }
        let oneMonth = (this.valueUser(this.qtdUser) + this.valueMemory(this.qtdMemory) + this.moreValue)
        let qtd_month = this.cupom['qtd_month'] ? this.cupom['qtd_month'] : 12
        let cupomValue = 0
        if (parseFloat(this.cupom.value) > 0) {
          cupomValue = this.cupom.type == 1 ? (oneMonth * (parseFloat(this.cupom.value) / 100)) : (parseFloat(this.cupom.value))
        }
        // O valor final será o valor do mes menos o valor do cupom vezes a quantidade de meses que o cupom estara ativo mais o valor de um mes vezes o restante dos meses, portanto se o cupom for ativo apenas por 3 meses, pega o valor dos 3 meses e soma com o valor dos 9 meses restantes.
        // E por fim multiplica por 0.9 incluindo os 10% de desconto
        let value = (((oneMonth - cupomValue) * qtd_month) + (oneMonth * (12 - qtd_month))) * 0.9
        return value < 1 ? 1 : value.toFixed(2)
      },
      card_style () {
        return {
          plane: {
            card_color: ''
          }
        }
      }
    }
  }
</script>

<style scoped>
  .name-company{
    color: teal !important;
  }

  .upgrade-layout{
    padding: 20px 0;
  }

  .upgrade-last-payment{
    position: absolute;
    left: 50%;
    top: 30vh;
    transform: translatex(-50%);
  }

  .btn-comprar{
    margin-top: 20px;
  }

  .last-payment-container{
    border: 2px solid #00acc2;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
  }

  .last-payment-container .title-upgrade{
    font-size: 2em;
  }

  .last-payment-body{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
  }

  .text-column{
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .last-payment-body .values-column{
    display: flex;
    flex-direction: column;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/Upgrade.vue